import { Button, ButtonProps } from '@mui/material';

export function SelectableButton({ children, isSelected, ...props }: ButtonProps & { isSelected: boolean }) {
  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: isSelected ? 'primary.main' : 'transparent',
        color: isSelected ? 'white' : undefined,
        '&:hover': { backgroundColor: isSelected ? 'primary.main' : undefined },
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
